<script>
import { useField } from 'vee-validate'
import { inject } from 'vue'
import appMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'formBankCode',
  components: {
    appMultiselect
  },
  props: {
    className: {
      type: String,
      default: 'form-input'
    },
    label: String,
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object,
      default: null
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const alreadySubmittedOnce = inject('alreadySubmittedOnce', false)

    const { value, errorMessage, handleChange } = useField(() => props.name, props.rules, {
      initialValue: props.modelValue,
      syncVModel: true,
      validateOnValueUpdate: false
    })

    const handleChangeValidation = (val) => {
      emit('update:modelValue', val)
      handleChange(val, alreadySubmittedOnce.value)
    }

    return {
      value,
      errorMessage,
      alreadySubmittedOnce,
      handleChangeValidation
    }
  }
}
</script>

<template>
  <div :class="className">
    <label :for="name">{{ label }}</label>
    <app-multiselect
      :model-value="value"
      @update:modelValue="handleChangeValidation"
      :options="options"
      track-by="key"
      label="name"
      :id="name"
      :name="name"
      placeholder="Selecione o banco"
      :class="{ invalid: alreadySubmittedOnce && !!errorMessage }"
    >
      <template #noResult>Nenhum resultado encontrado</template>
      <template #noOptions>Nenhuma opção disponível</template>
    </app-multiselect>
  </div>
</template>

<style lang="scss">
.invalid {
  .multiselect__tags {
    border-color: var(--error-color) !important;
  }
}
.text-danger {
  font-size: 0.85rem;
  color: #dc3545;
}
</style>
